document.addEventListener('DOMContentLoaded', function () {
    if (!page_popup.enabled) return
    // 创建样式
    const style = document.createElement('style');
    style.textContent = `
        .popup-content {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 80%;
            max-width: 90%;
            max-height: 90%;
            z-index: 99999999999999;
        }
        @media (min-width: 768px) {
            .popup-content {
                max-width: 500px;
            }
        }
        .popup-content img {
            width: 100%;
            height: auto;
            display: block;
        }
        .close-btn {
            position: absolute;
            top: 10px;
            right: 10px;
            color: #fff;
            font-size: 24px;
            cursor: pointer;
            background: none;
            border: none;
            width: 30px;
            height: 30px;
            background-color: rgba(0, 0, 0, .5);
            border-radius: 50%;
            z-index: 1;
        }
        .close-btn:hover {
            background-color: rgba(0, 0, 0, .7);
        }
    `;
    document.head.appendChild(style);

    // 检查今天是否已经显示过弹窗
    const lastShown = localStorage.getItem('popupLastShown');
    const today = new Date().toDateString();
    
    if (lastShown !== today) {
        // 创建弹窗元素
        const popup = document.createElement('div');
        popup.id = 'popup';
        popup.className = 'popup-content';
        popup.style.display = 'none';
        
        // 创建关闭按钮
        const closeBtn = document.createElement('button');
        closeBtn.className = 'close-btn';
        closeBtn.innerHTML = '&times;';
        
        // 创建图片链接
        const link = document.createElement('a');
        link.href = page_popup.link;
        link.style.display = 'block';
        link.style.width = '100%';
        
        // 创建图片
        const img = document.createElement('img');
        img.src = page_popup.image;
        
        // 图片加载完成后显示弹窗
        img.addEventListener('load', function() {
            popup.style.display = 'block';
            popup.style.width = img.width + 'px';
        });
        
        // 组装元素
        link.appendChild(img);
        popup.appendChild(closeBtn);
        popup.appendChild(link);
        document.body.appendChild(popup);
        
        // 点击关闭按钮关闭弹窗
        closeBtn.addEventListener('click', function() {
            popup.style.display = 'none';
            // 记录今天已经显示过弹窗
            localStorage.setItem('popupLastShown', today);
        });
    }
})